import { defineComponent as _defineComponent } from 'vue'
import { watchRelativeUrl } from '@/core/route.service';
import { onMounted, ref } from 'vue';
import StockTransferOrderService from './stock-transfer-order.service';
import QueryParamsService, { QueryParams } from '@/core/query-params.service';
import StockTransferOrderTable from './StockTransferOrderTable.vue';
import { useRouter } from 'vue-router/composables';
import StockTransferOrderLineViewObject = Vertica.LouisPoulsen.Application.PointOfSale.StockTransferOrder.StockTransferOrderLineViewObject;
import StockTransferOrderViewModel = Vertica.LouisPoulsen.Application.PointOfSale.StockTransferOrder.StockTransferOrderViewModel;


export default /*#__PURE__*/_defineComponent({
  __name: 'StockTransferOrder',
  props: {
    title: null
  },
  setup(__props: any) {



const orderNumber = ref<string>();
const previousOrderNumber = ref<string>(QueryParamsService.getParam(QueryParams.StockTransferOrderNumber) || null);

const orderLines = ref<StockTransferOrderLineViewObject[]>([]);

const router = useRouter();
const searchActive = ref<boolean>(false);

function updateQueryParams(): void {
    if (previousOrderNumber.value === orderNumber.value) {
        return;
    }
    const query = QueryParamsService.appendQueryParams([
        { name: QueryParams.StockTransferOrderNumber, value: orderNumber.value }
    ]);
    router.replace({ query });
};

function onRelativeUrlChange(route: RelativeUrl, oldRoute: RelativeUrl) {
    if (route && oldRoute && route.path === oldRoute.path) {
        get();
    }
}

watchRelativeUrl(onRelativeUrlChange);
onMounted(get);

async function get() {
    orderNumber.value = QueryParamsService.getParam(QueryParams.StockTransferOrderNumber);
    if (orderNumber.value) {
        searchActive.value = true;
        const apiResponse = await StockTransferOrderService.get(orderNumber.value);
        previousOrderNumber.value = orderNumber.value;
        searchActive.value = false;
        orderLines.value = apiResponse.lineItems;
    }
}

function update(newViewModel: StockTransferOrderViewModel) {
    orderLines.value = newViewModel.lineItems;
}


return { __sfc: true,orderNumber, previousOrderNumber, orderLines, router, searchActive, updateQueryParams, onRelativeUrlChange, get, update, StockTransferOrderTable }
}

})